/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export interface PinterestDomainVerificationProps {
    pinterestTag?: string | null;
}

/**
 * Renders the Pinterest domain-verification meta tag — the Storefront Next
 * equivalent of the `<isif>` block in the legacy `htmlhead.isml` template.
 * Pinterest event tracking itself is handled entirely through OneTrust's tag
 * management integration; this component only renders the static
 * `p:domain_verify` tag Pinterest uses to confirm site ownership.
 *
 * Renders nothing when no tag is configured.
 */
export function PinterestDomainVerification({ pinterestTag }: PinterestDomainVerificationProps) {
    if (!pinterestTag) return null;
    return <meta name="p:domain_verify" content={pinterestTag} />;
}
